import { DEFAULT_REDEEM as defaultRedeem } from './default';
import { VIEW_REWARD as viewReward } from './viewReward';

export const REDEEM = {
  defaultRedeem,
  viewReward
};
